(function () {
  'use strict';

  var STORAGE_KEY = 'meowella_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }

  function isWishlisted(handle) {
    return getWishlist().some(function(i){ return i.handle === handle; });
  }

  function toggleWishlist(item) {
    var list = getWishlist();
    var idx = -1;
    list.forEach(function(i, n){ if (i.handle === item.handle) idx = n; });
    if (idx > -1) { list.splice(idx, 1); saveWishlist(list); return false; }
    list.push(item); saveWishlist(list); return true;
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function(i){ return i.handle !== handle; }));
  }

  function updateHeaderCount() {
    var badge = document.getElementById('wishlist-header-count');
    if (!badge) return;
    var count = getWishlist().length;
    badge.textContent = count > 0 ? count : '';
    badge.style.display = count > 0 ? '' : 'none';
  }

  function getProductHandle() {
    var parts = window.location.pathname.split('/products/');
    if (parts.length > 1) return parts[1].split('?')[0].split('/')[0];
    return '';
  }

  function updateBtn(btn, wishlisted) {
    var svg = btn.querySelector('svg');
    var span = btn.querySelector('span');
    if (wishlisted) {
      btn.classList.add('wishlisted');
      if (svg) svg.style.fill = 'currentColor';
      if (span) span.textContent = 'Saved';
    } else {
      btn.classList.remove('wishlisted');
      if (svg) svg.style.fill = 'none';
      if (span) span.textContent = 'Save to Wishlist';
    }
  }

  function initBtn(btn) {
    if (btn.dataset.mwInit) return;
    btn.dataset.mwInit = '1';
    var handle = getProductHandle();
    var titleEl = document.querySelector('h1');
    var imgEl = document.querySelector('.product__media img, .media img, [data-media-type] img, .product-media img');
    var item = {
      handle: handle,
      title: titleEl ? titleEl.textContent.trim() : document.title.split(' – ')[0],
      image: imgEl ? (imgEl.src || '') : '',
      price: ''
    };
    if (handle) updateBtn(btn, isWishlisted(handle));
    btn.addEventListener('click', function() {
      if (!item.handle) { item.handle = getProductHandle(); }
      if (!item.handle) return;
      var added = toggleWishlist(item);
      updateBtn(btn, added);
      updateHeaderCount();
      btn.style.transform = 'scale(1.15)';
      setTimeout(function(){ btn.style.transform = ''; }, 300);
    });
  }

  function getHandleFromCard(btn) {
    // Find nearest product link to extract handle
    var card = btn.closest('product-card, li[data-product-id], [data-product-id]') || btn.parentElement;
    var link = card ? card.querySelector('a[href*="/products/"]') : null;
    if (!link) link = btn.closest('li')?.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var parts = href.split('/products/');
    return parts.length > 1 ? parts[1].split('?')[0].split('/')[0] : '';
  }

  function initCardBtn(btn) {
    if (btn.dataset.mwInit) return;
    btn.dataset.mwInit = '1';
    var handle = getHandleFromCard(btn);
    var svg = btn.querySelector('svg');
    // Set initial state
    if (handle && isWishlisted(handle)) {
      btn.classList.add('wishlisted');
      if (svg) svg.style.fill = 'currentColor';
      btn.title = 'Saved to Wishlist';
    }
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var h = getHandleFromCard(btn);
      if (!h) return;
      var card = btn.closest('product-card, li[data-product-id], [data-product-id]') || btn.parentElement;
      var link = card ? card.querySelector('a[href*="/products/"]') : null;
      var li = btn.closest('li');
    var titleEl = (li || card).querySelector('h3, h2, h4, .h4, .h3, [class*="product-title"], [class*="card-title"]') || null;
      var imgEl = card ? card.querySelector('img') : null;
      var item = {
        handle: h,
        title: titleEl ? titleEl.textContent.trim() : h,
        image: imgEl ? (imgEl.src || '') : '',
        price: ''
      };
      var added = toggleWishlist(item);
      var svgEl = btn.querySelector('svg');
      if (added) {
        btn.classList.add('wishlisted');
        if (svgEl) svgEl.style.fill = 'currentColor';
        btn.title = 'Saved to Wishlist';
      } else {
        btn.classList.remove('wishlisted');
        if (svgEl) svgEl.style.fill = 'none';
        btn.title = 'Save to Wishlist';
      }
      updateHeaderCount();
      btn.style.transform = 'scale(1.2)';
      setTimeout(function(){ btn.style.transform = ''; }, 300);
    });
  }

  function observeButtons() {
    function scan(root) {
      (root.querySelectorAll ? root.querySelectorAll('.meow-wish-product-btn') : []).forEach(initBtn);
      if (root.classList && root.classList.contains('meow-wish-product-btn')) initBtn(root);
      (root.querySelectorAll ? root.querySelectorAll('.meow-wish-btn') : []).forEach(initCardBtn);
      if (root.classList && root.classList.contains('meow-wish-btn')) initCardBtn(root);
    }
    scan(document);
    var obs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(n) { if (n.nodeType === 1) scan(n); });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function renderWishlistPage() {
    var container = document.getElementById('meow-wishlist-container');
    if (!container) return;
    var list = getWishlist();
    var heartSvg = '<svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    if (list.length === 0) {
      container.innerHTML = '<div class="meow-wishlist-empty">' + heartSvg + '<p>Your wishlist is empty.</p><a href="/collections/all" class="button">Browse Jewellery</a></div>';
      return;
    }
    container.innerHTML = '<p class="meow-wishlist-loading">Loading your wishlist…</p>';
    Promise.all(list.map(function(item) {
      return fetch('/products/' + item.handle + '.js').then(function(r){ return r.json(); }).catch(function(){ return null; });
    })).then(function(products) {
      var valid = products.filter(Boolean);
      if (!valid.length) { container.innerHTML = '<p>Could not load wishlist items.</p>'; return; }
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
      var html = '<div class="meow-wishlist-grid">';
      valid.forEach(function(p) {
        var img = p.images && p.images[0] ? '<img src="' + p.images[0] + '" alt="' + p.title + '" loading="lazy">' : '<div class="meow-wishlist-no-img"></div>';
        var price = p.variants && p.variants[0] ? (p.variants[0].price / 100).toFixed(2) : '0.00';
        html += '<div class="meow-wishlist-card" data-handle="' + p.handle + '">' +
          '<a href="/products/' + p.handle + '" class="meow-wishlist-card__img">' + img + '</a>' +
          '<div class="meow-wishlist-card__body">' +
          '<a href="/products/' + p.handle + '" class="meow-wishlist-card__name">' + p.title + '</a>' +
          '<div class="meow-wishlist-card__price">' + currency + ' ' + price + '</div>' +
          '<div class="meow-wishlist-card__actions">' +
          '<a href="/products/' + p.handle + '" class="button button--secondary">View</a>' +
          '<button class="meow-wishlist-remove" data-handle="' + p.handle + '">Remove</button>' +
          '</div></div></div>';
      });
      html += '</div>';
      container.innerHTML = html;
      container.querySelectorAll('.meow-wishlist-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var h = this.dataset.handle;
          removeFromWishlist(h);
          var card = this.closest('.meow-wishlist-card');
          if (card) card.remove();
          updateHeaderCount();
          if (getWishlist().length === 0) renderWishlistPage();
        });
      });
    });
  }

  function injectStyles() {
    if (document.getElementById('meow-wishlist-styles')) return;
    var rules = [
      /* Fix mobile search back to left side (next to hamburger) */
      '.search-action{grid-area:leftB!important}',
      /* Wishlist link - sizing handled by header-actions__action class */
      '.header-actions__wishlist{position:relative;text-decoration:none;color:inherit;}',
      '.header-actions__wishlist svg{display:block;width:24px;height:24px;transition:fill .2s;}',
      '#wishlist-header-count{position:absolute;top:4px;right:4px;min-width:14px;height:14px;border-radius:50%;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;line-height:1;padding:0 2px;background:currentColor;color:#fff;}',
      '.meow-wish-product-btn{transition:transform .2s ease;}',
      '.meow-wish-product-btn.wishlisted svg{fill:currentColor;}',
      '.meow-wishlist-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:20px;padding:24px 0;}',
      '.meow-wishlist-card{border:1px solid rgba(0,0,0,.1);border-radius:8px;overflow:hidden;}',
      '.meow-wishlist-card__img img,.meow-wishlist-no-img{width:100%;aspect-ratio:1;object-fit:cover;display:block;}',
      '.meow-wishlist-no-img{background:#f5f5f5;}',
      '.meow-wishlist-card__body{padding:12px;}',
      '.meow-wishlist-card__name{display:block;font-size:13px;font-weight:500;text-decoration:none;color:inherit;margin-bottom:4px;}',
      '.meow-wishlist-card__price{font-size:12px;opacity:.65;margin-bottom:10px;}',
      '.meow-wishlist-card__actions{display:flex;gap:8px;align-items:center;flex-wrap:wrap;}',
      '.meow-wishlist-remove{background:none;border:none;cursor:pointer;color:inherit;font-size:12px;opacity:.55;padding:4px 0;text-decoration:underline;}',
      '.meow-wishlist-remove:hover{opacity:1;}',
      '.meow-wishlist-empty{text-align:center;padding:60px 20px;}',
      '.meow-wishlist-empty svg{margin:0 auto 16px;display:block;opacity:.3;}',
      '.meow-wishlist-empty p{margin-bottom:20px;font-size:15px;opacity:.7;}',
      '.meow-wishlist-loading{text-align:center;padding:40px;opacity:.6;}'
    ];
    var s = document.createElement('style');
    s.id = 'meow-wishlist-styles';
    s.textContent = rules.join('');
    document.head.appendChild(s);
  }

  function init() {
    injectStyles();
    updateHeaderCount();
    observeButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
